<template>
    <div id="contact" class="container-fluid">
        <div class="row">
            <!-- <div class="contenedor"> -->
            <div class="hola col-xs-12 col-md-6 col-md-offset-4">
                <h1 data-aos="fade">{{ msg }}</h1>
                <hr>
                <h5 data-aos="fade">
                    <span>ADDRESS</span>
                </h5>
                <h5 class="margin"> 9655 Granite Ridge Dr #200</h5><br>
                <h5 data-aos="fade">
                    <span>PHONE</span>
                </h5>
                <h5 class="margin">+18582433842 <br></h5> <br>
                <h5 data-aos="fade">
                    <span>MAIL</span>
                </h5>
                <h5 class="margin">asantamaria@intqd.com</h5><br>
                <img class="img" src="../assets/cuadro_gris.png" alt="" width="60%" data-aos="fade-up">
            </div>
        </div>
        <!-- <div class="img2"></div> -->
        <!-- <img src="../assets/foto4.jpg" alt="" width="100%"> -->
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3353.4866224197826!2d-117.12167018481718!3d32.80586908096329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d95587238868e5%3A0x791c51508e260678!2s9655+Granite+Ridge+Dr+%23200%2C+San+Diego%2C+CA+92123%2C+EE.+UU.!5e0!3m2!1ses!2smx!4v1513796904764" width="100%" height="600px" frameborder="0" style="border:0;margin:0px;padding:0px;" allowfullscreen data-aos="fade-up"></iframe>

        <footer>
            <div class="col-xs-12 col-md-6 col-md-offset-3 text-center">
                <h4>Copyright@2017</h4>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'quote',
    data() {
        return {
            msg: 'CONTACT US',
            info: {
                address: 'ADRESS     Lorem ipsum dolo 000',
                phone: 'PHONE      (000) 12345678',
                mail: 'MAIL          correo@intqd.com'
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-fluid{
    height: 80vh !important;
}
h1 {
    font-weight: bold;
    color: white;
    position: absolute;
    text-align: center;
    padding-top: 250px;
    left: 180px;
    z-index: 3;
}

h5 {
    color: white;
    position: absolute;
    text-align: left;
    padding-top: 380px;
    left: 180px;
    z-index: 3;
    line-height: 22px;
}

hr {
    border: 1px solid #eee;
    position: absolute !important;
    top: 330px;
    left: 210px;
    z-index: 9999;
    width: 20%;
}

h4 {
    color: white;
    text-align: center;
    font-size: 10pt;
    padding: 20px 0 20px 0;
}

footer {
    height: 100px;
    background-color: #333434;
    margin: 0px;
    padding: 0px;
    margin-top:30px;
}


span {
    font-weight: bolder;
    color: white;
    padding-right: 40px;
}

.margin {
    padding-left: 100px;
}


.contenedor {
    position: relative;
    top: 380px;
}

.img {
    position: absolute;
    text-align: left;
    padding-top: 110px;
    left: 15px;
    z-index: 2;
}

.img2 {
    height: 300px;
    background-image: url("../assets/foto4.jpg");
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.container-fluid {
    height: 100vh;
    margin: 0px;
    padding: 0px;
}

@media screen and (max-width: 1450px) {
    h1 {
        left: 110px;
        margin: auto;
        ;
    }

    hr{
        left: 160px;
        margin: auto;
    }

    h5{
        margin: auto;
        margin-top: -17px;
        left:85px;
    }

    .img{
        margin-top:40px;
    }
}

/*horizontal tablet */

@media screen and (max-width: 1024px)
{
    .img{
        margin-top: 85px;
        width: 85%;
    }

    h1, hr, h5{
       margin-top:60px; 
    }

    hr{
        margin-left: 20px;
    }

}


/* tablet */

@media screen and (max-width: 991px) {
    .img{
        margin-left: 140px;
        margin-top:100px;
        width: 60%;
    }
    h1{
        position: absolute;
        margin: 0px;
        padding: 0px;
        /* padding-bottom: 30px; */
        top:620px;
        left: 280px;
        text-align: center;
        color:white;
    }


span {
    font-weight: bolder;
    color: white;
    padding-right: 10px;
}
h5 {
    color: white;
    position: absolute;
    text-align: left;
    /* padding-top: 700px; */
    left: 280px;
    z-index: 3;
    line-height: 22px;
}

.margin {
    padding-left: 0px;
}

    hr{
        display: none;
    }

    .margin{
        margin-left:100px;
    }

    
}


/* mobile */

@media screen and (max-width: 767px) {
    img {
        display: none;
    }
    .hola{
  background-color: #333434;
    }
    h1,
    h5,
    span {
        position: relative !important;
        top:0px;
        left: 0px !important;
        margin: 0px;
        padding: 0px;
        text-align: center;
    }

    .margin{
        margin: 0px;
    }

    h1 {
        padding-top: 30px;
        padding-bottom:30px;
        z-index: 1 !important;
    }

    h5{
        z-index: 1!important;
    }

    h4 {
        padding: 0px;
        font-size: 10pt;
    }
    
    .img2{
        display:none;
    }
}

@media screen and (max-width: 500px){
    footer{
        margin:0px;
        height: 80px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue